<app-error-shell>
  <div class="error-page">
    <span class="error-page__icon" aria-hidden="true">🧭</span>
    <span class="error-page__code">404</span>
    <h1 class="error-page__title">{{ 'errors.not_found.title' | translate }}</h1>
    <p class="error-page__subtitle">{{ 'errors.not_found.subtitle' | translate }}</p>
    <a [routerLink]="authService.isAuthenticated() ? routes.DASHBOARD : routes.HOME" class="error-page__cta">
      {{ (authService.isAuthenticated() ? 'errors.cta.go_to_dashboard' : 'errors.cta.go_to_home') | translate }} ›
    </a>
  </div>
</app-error-shell>
